import { format, parseISO } from "date-fns"

export const fillCopy = (template, values = {}) =>
  template.replace(/%\{(\w+)\}/g, (placeholder, key) =>
    key in values ? String(values[key]) : placeholder
  )

export const countedCopy = (forms, count, values = {}) =>
  fillCopy(count === 1 ? forms.one : forms.other, { ...values, count })

export const formatInvoiceDate = (date) => format(parseISO(date), "MMM d, yyyy")
